module.exports = __webpack_public_path__ + "img/dosificacion_6.858a398f.png";